import { createContext, useContext, useState } from "react";

const ModalContext = createContext(null);
export const useModals = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [consultation, setConsultation] = useState(null); // {productInterest}
  const [whiteGlove, setWhiteGlove] = useState(null); // {product}
  const [quote, setQuote] = useState(null); // {purpose}

  return (
    <ModalContext.Provider
      value={{
        consultation,
        whiteGlove,
        quote,
        openConsultation: (productInterest = "") => setConsultation({ productInterest }),
        closeConsultation: () => setConsultation(null),
        openWhiteGlove: (product) => setWhiteGlove({ product }),
        closeWhiteGlove: () => setWhiteGlove(null),
        openQuote: (purpose = "") => setQuote({ purpose }),
        closeQuote: () => setQuote(null),
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}
